export const WhatWeMake = () => (
  <section className="section" data-section="what-we-make">
    <div className="section-inner">
      <span className="section-eyebrow">In plain English</span>
      <h2>What Bancony makes.</h2>

      <div className="whatwemake-grid">
        <div className="whatwemake-block">
          <div className="whatwemake-tag">Bancony Server</div>
          <p>
            Makes your bank's digital banking data and operations accessible to AI
            agents, securely and in a standard way. Customers' balances, transactions,
            payments, and other everyday banking actions become things an AI agent
            can read or do, with the bank's existing controls in place.
          </p>
          <p className="whatwemake-tech">
            Standard: <a href="https://bank2ai.com" target="_blank" rel="noopener noreferrer" className="bank2ai-link">bank2ai</a> (built on MCP).
          </p>
        </div>

        <div className="whatwemake-block">
          <div className="whatwemake-tag">Bancony Assistant</div>
          <p>
            A customer-facing AI assistant that talks to Bancony Server (or any
            other bank2ai-compliant server) to help your customers manage their
            money. Lives inside your bank's own app, wears your bank's brand, uses
            your bank's identity.
          </p>
          <p className="whatwemake-tech">
            Drops seamlessly into your bank's web and mobile apps, with no new login.
          </p>
        </div>
      </div>

      <p className="whatwemake-summary">
        Take both, or just one. Run the Server and bring your own assistant. Run the
        Assistant against a bank2ai server you've built yourself, or one from another
        vendor. Whatever you pick, you're building on an open standard your bank
        fully owns, not on a vendor's proprietary stack.
      </p>
    </div>
  </section>
);
